import http from "@/http-common";

class InquiryInfoDataService {
  getInquiryInfo(data: any): Promise<any> {
    return http.api.post("/getInquiryInfo/", data);
  }
}
export default new InquiryInfoDataService();
